import { useEffect, useCallback, useState } from 'react';
import { getStampHistory } from 'api/stampHistory';
import StampHistoryDomain from 'domain/master/atendenceManagement/stampHistory';


const useStampHistory = (orgCode: string, targetDateFrom: string, targetDateTo: string) => {
  const [stampHistory, setstampHistory] = useState<Array<StampHistoryDomain>>([]);
  const [blocking, setBlocking] = useState(false);

  // データの取得
  const fetchData = useCallback(async () => {
    setBlocking(true);
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
    const response = await getStampHistory(companyCode, orgCode, targetDateFrom, targetDateTo);
    setstampHistory(response.map((result: any) => new StampHistoryDomain(result)));
    setBlocking(false);
  }, [orgCode, targetDateFrom, targetDateTo]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { stampHistory, setstampHistory, blocking };
};

export default useStampHistory;
